import React from 'react';

const Datenschutz = () => {
  return (
    <section id="datenschutz" className="py-20 px-4 bg-gradient-to-b from-black to-[#0a0a0a] min-h-screen">
      <div className="max-w-4xl mx-auto">
        {/* Section Title */}
        <div className="mb-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Datenschutzerklärung
          </h1>
          <div className="w-24 h-1 bg-amber-500 mx-auto" />
        </div>

        <div className="bg-gray-900/50 rounded-lg border border-gray-800 p-8 md:p-12 space-y-8">
          
          {/* Einleitung */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Allgemeine Hinweise</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Verantwortliche Stelle</h3>
            <p className="text-gray-300 leading-relaxed mb-2">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
            </p>
            <div className="text-gray-300 bg-gray-900 p-4 rounded-lg border border-gray-800 mb-4">
              <p className="font-semibold text-white">Fabio Matt</p>
              <p>Heragass 22</p>
              <p>9492 Eschen</p>
              <p>Liechtenstein</p>
              <p className="mt-2">
                <span className="text-gray-400">Telefon:</span> +423 781 53 06
              </p>
              <p>
                <span className="text-gray-400">E-Mail:</span> <a href="mailto:fabiomatt2005@gmail.com" className="text-amber-400 hover:text-amber-300">fabiomatt2005@gmail.com</a>
              </p>
            </div>
          </div>

          {/* Datenerfassung */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">2. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Hosting</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website 
              erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich 
              v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, 
              Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert 
              werden, handeln.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber potenziellen und 
              bestehenden Kunden sowie zur Bereitstellung einer sicheren, schnellen und effizienten 
              Online-Präsenz durch einen professionellen Anbieter.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Server-Log-Dateien</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Der Provider dieser Website erhebt und speichert automatisch Informationen in 
              sogenannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL (die zuvor besuchte Seite)</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p className="text-gray-300 leading-relaxed mb-4">
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. 
              Die Daten werden auf Grundlage berechtigter Interessen zur Sicherstellung eines 
              störungsfreien Betriebs der Website sowie zur Verbesserung des Angebots gespeichert.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Kontaktformular</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Wenn Sie mir über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben 
              aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
              Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei mir gespeichert.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Die Datenverarbeitung zum Zwecke der Kontaktaufnahme erfolgt auf Grundlage Ihrer 
              freiwillig erteilten Einwilligung. Die für die Benutzung des Kontaktformulars von 
              mir erhobenen personenbezogenen Daten werden nach Erledigung der von Ihnen gestellten 
              Anfrage automatisch gelöscht.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">E-Mail-Kontakt</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Wenn Sie mir per E-Mail Anfragen zukommen lassen, werden Ihre Angaben inklusive der 
              von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den 
              Fall von Anschlussfragen bei mir gespeichert. Diese Daten werden ohne Ihre Einwilligung 
              nicht weitergegeben. Die Verarbeitung erfolgt auf Grundlage Ihrer freiwillig erteilten 
              Einwilligung.
            </p>
          </div>

          {/* Cookies */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">3. Cookies</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Website verwendet derzeit nur technisch notwendige Cookies. Cookies sind kleine 
              Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. 
              Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Die meisten der verwendeten Cookies sind sogenannte „Session-Cookies". Sie werden nach 
              Ende Ihres Besuchs automatisch gelöscht. Sie können Ihren Browser so einstellen, dass 
              Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben.
            </p>
          </div>

          {/* Google Analytics */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">4. Analyse-Tools und Tools von Drittanbietern</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Google Analytics (falls aktiviert)</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Website kann Google Analytics verwenden, einen Webanalysedienst der Google Ireland 
              Limited („Google"). Google Analytics verwendet Cookies, die eine Analyse der Benutzung 
              der Website durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre 
              Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen 
              und dort gespeichert.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Google wird diese Informationen verwenden, um Ihre Nutzung der Website auszuwerten, 
              um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der 
              Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer 
              Browser-Software verhindern. Sie können darüber hinaus die Erfassung der durch das 
              Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten an Google sowie die 
              Verarbeitung dieser Daten durch Google verhindern, indem Sie das Browser-Add-on 
              herunterladen und installieren, das unter folgendem Link verfügbar ist: 
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-300 ml-1">
                https://tools.google.com/dlpage/gaoptout
              </a>.
            </p>
          </div>

          {/* Social Media */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">5. Soziale Medien</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Links zu Instagram und TikTok</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Website enthält Links zu meinen Social-Media-Profilen auf Instagram und TikTok. 
              Diese Links sind als einfache Hyperlinks umgesetzt. Es werden keine Plugins der 
              Sozialen Netzwerke eingebunden, die automatisch Daten übertragen.
            </p>
            <p className="text-gray-300 leading-relaxed mb-4">
              Wenn Sie auf diese Links klicken, werden Sie zu den jeweiligen Plattformen weitergeleitet. 
              Erst ab diesem Zeitpunkt werden Ihre Daten an die Betreiber der jeweiligen Plattformen 
              übertragen. Für den Umgang mit Ihren Daten auf diesen Plattformen sind die jeweiligen 
              Betreiber verantwortlich:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
              <li>
                <strong className="text-white">Instagram:</strong> Meta Platforms Ireland Limited, 
                4 Grand Canal Square, Dublin 2, Irland
              </li>
              <li>
                <strong className="text-white">TikTok:</strong> TikTok Technology Limited, 
                10 Earlsfort Terrace, Dublin, D02 T380, Irland
              </li>
            </ul>
          </div>

          {/* Ihre Rechte */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">6. Ihre Rechte</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Sie haben das Recht:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
              <li>Auskunft über Ihre bei mir gespeicherten personenbezogenen Daten zu verlangen</li>
              <li>Die Berichtigung unrichtiger Daten zu verlangen</li>
              <li>Die Löschung Ihrer Daten zu verlangen</li>
              <li>Die Einschränkung der Datenverarbeitung zu verlangen</li>
              <li>Der Datenverarbeitung zu widersprechen</li>
              <li>Ihre Daten in einem gängigen Format zu erhalten (Datenübertragbarkeit)</li>
              <li>Sich bei einer Aufsichtsbehörde zu beschweren</li>
            </ul>
            <p className="text-gray-300 leading-relaxed mb-4">
              Wenn Sie eines dieser Rechte ausüben möchten, kontaktieren Sie mich bitte unter:
            </p>
            <div className="text-gray-300 bg-gray-900 p-4 rounded-lg border border-gray-800 mb-4">
              <p>
                <span className="text-gray-400">E-Mail:</span> <a href="mailto:fabiomatt2005@gmail.com" className="text-amber-400 hover:text-amber-300">fabiomatt2005@gmail.com</a>
              </p>
            </div>
          </div>

          {/* Widerruf */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">7. Widerruf Ihrer Einwilligung zur Datenverarbeitung</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
              Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit 
              der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>
          </div>

          {/* Beschwerderecht */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">8. Beschwerderecht bei der zuständigen Aufsichtsbehörde</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Im Falle von Verstößen gegen datenschutzrechtliche Vorschriften steht den Betroffenen 
              ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde 
              in Liechtenstein ist:
            </p>
            <div className="text-gray-300 bg-gray-900 p-4 rounded-lg border border-gray-800 mb-4">
              <p className="font-semibold text-white">Datenschutzstelle Liechtenstein</p>
              <p>Städtle 38, Postfach 684</p>
              <p>9490 Vaduz</p>
              <p>Liechtenstein</p>
              <p className="mt-2">
                <span className="text-gray-400">Telefon:</span> +423 236 60 90
              </p>
              <p>
                <span className="text-gray-400">E-Mail:</span> <a href="mailto:info@datenschutzstelle.li" className="text-amber-400 hover:text-amber-300">info@datenschutzstelle.li</a>
              </p>
              <p className="mt-2">
                <span className="text-gray-400">Website:</span> <a href="https://www.datenschutzstelle.li" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-300">www.datenschutzstelle.li</a>
              </p>
            </div>
          </div>

          {/* SSL/TLS */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">9. SSL- bzw. TLS-Verschlüsselung</h2>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher 
              Inhalte, wie zum Beispiel Anfragen, die Sie an mich als Seitenbetreiber senden, eine 
              SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass 
              die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol 
              in Ihrer Browserzeile.
            </p>
            <p className="text-gray-300 leading-relaxed">
              Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an mich 
              übermitteln, nicht von Dritten mitgelesen werden.
            </p>
          </div>

          {/* Änderungen */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">10. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-gray-300 leading-relaxed">
              Ich behalte mir vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen 
              rechtlichen Anforderungen entspricht oder um Änderungen meiner Leistungen in der 
              Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue 
              Datenschutzerklärung.
            </p>
          </div>

          {/* Stand */}
          <div className="pt-8 border-t border-gray-800">
            <p className="text-gray-500 text-sm">
              Stand: Januar 2025
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Datenschutz;
